import { FC } from "react";
import { Box } from "@chakra-ui/react";

export const ChunkDivider: FC = () => {
  return (
    <Box
      bg="fg-on-accent"
      h={{ base: "0.25rem", lg: "15rem" }}
      mx={{ base: "0", lg: 4, xl: 20 }}
      my={{ base: 12, lg: "0" }}
      w={{ base: "100%", lg: "0.25rem" }}
    />
  );
};
